// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_ComprovantesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * GET /subscriptions/setup-fee/comprovantes/:franquia_id (e os POSTs que mudam um comprovante) —
 * os comprovantes da franquia e se ela pode mandar um agora. Chamado NS 2026-0079, F3.
 */
import type { SetupFee_ComprovanteRow } from './SetupFee_ComprovanteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_ComprovantesResponseDados {
franquia_id: number
setup_status: string
moeda: string
comprovantes: SetupFee_ComprovanteRow[]
bloqueio?: string
}

export type SetupFee_ComprovantesResponse = ApiResponse<SetupFee_ComprovantesResponseDados>;

registerResponseContract('SetupFee_ComprovantesResponse', {
  franquia_id:  { type: 'number',  required: true },
  setup_status: { type: 'string',  required: true },
  moeda:        { type: 'string',  required: true },
  comprovantes: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'number',  required: true },
      franquia_id:   { type: 'number',  required: true },
      franquia_nome: { type: 'string',  required: false },
      situacao:      { type: 'string',  required: true },
      valor_cents:   { type: 'number',  required: true },
      moeda:         { type: 'string',  required: true },
      pago_em:       { type: 'string',  required: true },
      arquivo_nome:  { type: 'string',  required: false },
      enviado_por:   { type: 'string',  required: false },
      enviado_em:    { type: 'string',  required: true },
      revisado_por:  { type: 'string',  required: false },
      revisado_em:   { type: 'string',  required: false },
      motivo:        { type: 'string',  required: false },
    },
  },
  bloqueio:     { type: 'string',  required: false },
})
